module.exports = __webpack_public_path__ + "static/media/longEShortITest.71fc93e5.mp3";